export const loadPageComponent = page => {
  const pages = import.meta.glob([
    "../pages/**/*.js",
    "!../pages/**/(__tests__|components|assets|utils|hooks|widgets|test-support|support|store|queries|default-content|templates)/**/*.js",
    "!../pages/**/(constants|typedefs).js"
  ])

  const pageFn =
    pages[`../pages/${page}.js`] || pages[`../pages/${page}/index.js`]

  return pageFn()
}
